/**
 * Pure helpers for the match-start D20 first-player roll.
 *
 * No DOM, no Three.js. Just numbers and message shapes. Lets the
 * orchestration logic (FirstPlayerDiceModal) reason about the same
 * primitives without dragging in render dependencies.
 *
 * Online, the server arbitrates the roll (REQUEST_ROLL) and the values
 * arrive via the authoritative mirror; sandbox rolls locally.
 */

export const D20_FACES = 20;

export function rollD20() {
  return 1 + Math.floor(Math.random() * D20_FACES);
}

/**
 * Decide the outcome of two D20 rolls from the host's perspective.
 * Returns 'host', 'guest', or 'tie'.
 *
 * Pure. Same input always gives the same output. The randomness
 * lives in rollD20(), not here.
 */
export function decideWinner(hostRoll, guestRoll) {
  if (hostRoll === guestRoll) return 'tie';
  return hostRoll > guestRoll ? 'host' : 'guest';
}

/**
 * Map the host-perspective winner ('host' | 'guest' | 'tie') to a
 * seat number (1 | 2 | null). Seat 1 is whoever is host of the
 * connection; seat 2 is the guest. Returns null on tie so the
 * caller can detect the re-roll path without string comparison.
 */
export function winnerToSeat(winner) {
  if (winner === 'host') return 1;
  if (winner === 'guest') return 2;
  return null;
}
